export default {
  sections: {
    business_info: 'Información de empresa',
    bank_info: 'Información bancaria',
  },
  form: {
    company_name: {
      label: 'Nombre del restaurante',
      placeholder: 'Nombre del restaurante',
    },
    business_name: {
      label: 'Nombre de la empresa',
      placeholder: 'Nombre de la empresa',
    },
    owner_full_name: {
      label: 'Nombre del propietario',
      placeholder: 'Nombre del propietario',
    },
    business_address: {
      label: 'Dirección de la empresa',
      placeholder: 'Dirección de la empresa',
    },
    business_zip_code: {
      label: 'Código postal de la empresa',
      placeholder: 'Código postal de la empresa',
    },
    business_city: {
      label: 'Ciudad de la empresa',
      placeholder: 'Ciudad de la empresa',
    },
    business_country: {
      label: 'País de la empresa',
      options: {
        DE: 'Alemania',
        GB: 'Reino Unido',
        US: 'Estados Unidos',
      },
    },
    company_phone_number: {
      label: 'Número de teléfono del restaurante',
      placeholder: 'Número de teléfono del restaurante',
    },
    contact_person_full_name: {
      label: 'Nombre del contacto',
      placeholder: 'Nombre del contacto',
    },
    contact_person_phone_number: {
      label: 'Teléfono del contacto',
      placeholder: 'Teléfono del contacto',
    },
    contact_person_email: {
      label: 'Correo del contacto',
      placeholder: 'Correo del contacto',
    },
    business_bank_account_holder_name: {
      label: 'Titular de la cuenta bancaria',
      placeholder: 'Titular de la cuenta bancaria',
    },
    business_bank_account_number: {
      label: 'Número de cuenta bancaria',
      placeholder: 'DE01101234567891234567',
    },
    business_bank_routing_number: {
      label: 'Número de ruta bancaria',
      placeholder: '110000000',
    },
    business_tax_id: {
      label: 'NIF de la empresa',
      placeholder: 'NIF de la empresa',
    },
  },
};
